import React from 'react';

import styled, { css } from 'styled-components';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { getColorFromKey } from 'constants/helper';
import theme from 'constants/theme';

const Wrapper = styled.div`
  display: flex;
  max-width: ${(props) => (props.isMobileVersion ? '1000px' : '450px')};
  min-width: ${(props) => (props.isMobileVersion ? '200px' : '280px')};
  justify-content: flex-start;
  &:nth-last-child {
    margin-right: 0 !important;
  }
`;

const ClickableWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 32px;
  max-width: ${(props) => (props.isMobileVersion ? '300px' : '50px')};
  margin: 0 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:nth-child(1) {
    margin-left: 0 !important;
  }
  &:nth-child(n) {
    margin-right: 0 !important;
  }
`;

const StyledStepperItem = styled.div`
  flex-grow: 1;
  height: ${(props) => (props.isMobileVersion ? '10px' : '7px')};
  border-radius: 3px;
  ${(props) =>
    props.type &&
    props.type === 'fill' &&
    css`
      background-color: ${(props) => getColorFromKey(props.color)};
    `};

  border: 1px solid ${(props) => getColorFromKey(props.color)};
`;

const StepperItem = (props) => (
  <ClickableWrapper onClick={props.clickHandler} isMobileVersion={props.isMobileVersion}>
    <StyledStepperItem {...props} />
  </ClickableWrapper>
);

export const QuestionStepper = ({ data, currentItemId, clickHandler, isMobileVersion = false, wrapperProps = {} }) => {
  const getProps = ({ id, isAnswered, isRequired, isVisited }) => {
    const type = id === currentItemId ? 'outline' : 'fill';
    // eslint-disable-next-line no-nested-ternary
    const color = !isVisited ? 'grey' : isRequired && !isAnswered ? theme.palette.error.dark : theme.palette.icons.blue;
    // eslint-disable-next-line no-nested-ternary
    const deerColor = !isVisited ? '#B0B0B0' : isRequired && !isAnswered ? '#C62C02' : '#0D819F';
    return { type, color: checkNewNavEnabled() ? deerColor : color };
  };
  return (
    <Wrapper isMobileVersion={isMobileVersion} {...wrapperProps}>
      {data.map((item) => (
        <StepperItem {...getProps(item)} key={item.id} clickHandler={() => clickHandler(item.id)} />
      ))}
    </Wrapper>
  );
};

export default QuestionStepper;
